import { Spin } from 'antd';
import { Suspense } from 'react';
import { lazyRoute } from './lazy-route';

const VisitDashboardPage = lazyRoute(() => import('pages/visit-dashboard/visit-dashboard.container'));

const VisitDashboard = () => (
  <Suspense fallback={<Spin fullscreen />}>
    <VisitDashboardPage />
  </Suspense>
);

export default VisitDashboard;
